export enum DOCUMENT_ACTION_TYPES {
  VIEW = 'VIEW',
  DOWNLOAD = 'DOWNLOAD',
}

export enum DOCUMENT_LIST_SIZES {
  SMALL = 'SMALL',
  FULL = 'FULL',
}
